import { formatUsPhoneDisplay } from './phoneUtils';

/**
 * Centralized formatting utilities.
 *
 * Rules:
 *  - Dollar amounts: 2 decimal places  (e.g. $250,000.00)
 *  - Pricing-related dollars (price, points, lender credits): 3 decimal places
 *  - Ratios (DTI, etc.): 2 decimal places  (e.g. 43.25%)
 *  - LTV / CLTV / HCLTV: 2 decimal places  (e.g. 80.00%)
 *  - Rates / pricing percentages: 3 decimal places (e.g. 6.500%)
 */

/** Standard dollar — 2 decimal places */
export const fmtDollar = (v) =>
  v != null
    ? `$${Number(v).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
    : '—';

/** Pricing dollar — 3 decimal places (price, points, lender credits) */
export const fmtPricingDollar = (v) =>
  v != null
    ? `$${Number(v).toLocaleString(undefined, { minimumFractionDigits: 3, maximumFractionDigits: 3 })}`
    : '—';

/** Standard percentage / ratio — 2 decimal places (DTI, LTV, CLTV, HCLTV) */
export const fmtPct = (v) =>
  v != null ? `${Number(v).toFixed(2)}%` : '—';

/** Pricing percentage — 3 decimal places (interest rate, price, margin) */
export const fmtPricingPct = (v) =>
  v != null ? `${Number(v).toFixed(3)}%` : '—';

/** Plain number with commas, no currency symbol */
export const fmtNum = (v) =>
  v != null ? Number(v).toLocaleString() : '—';

/** Date — locale short format */
export const fmtDate = (v) =>
  v ? new Date(v).toLocaleDateString() : '—';

/** Phone — formats a digit string or partially formatted number to (XXX) XXX-XXXX */
export const fmtPhone = (v) => {
  if (!v) return '—';
  const digits = String(v).replace(/\D/g, '');
  if (digits.length === 0) return '—';
  if (digits.length <= 3) return digits;
  if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 10)}`;
};

/** US-style phone as you type — for controlled inputs (max 10 national digits). */
export const formatPhoneInputValue = (value) => formatUsPhoneDisplay(value);
